import { render, staticRenderFns } from "./TestNotStarted.vue?vue&type=template&id=6e28be4a&scoped=true&"
import script from "./TestNotStarted.vue?vue&type=script&lang=js&"
export * from "./TestNotStarted.vue?vue&type=script&lang=js&"
import style0 from "./TestNotStarted.vue?vue&type=style&index=0&id=6e28be4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e28be4a",
  null
  
)

export default component.exports